import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import App from "./App";
import Landing from "./routes/Landing";
import Callback from "./routes/Callback";
import Dashboard from "./routes/Dashboard";
import Accounts from "./routes/Accounts";
import Firms from "./routes/Firms";
import Data from "./routes/Data";
import TradeLog from "./routes/TradeLog";
import Payouts from "./routes/Payouts";
import RequireAuth from "./components/RequireAuth";

import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("No #root element found in index.html");

createRoot(root).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route element={<App />}>
          <Route index element={<Landing />} />
          <Route path="callback" element={<Callback />} />
          <Route
            path="dashboard"
            element={
              <RequireAuth>
                <Dashboard />
              </RequireAuth>
            }
          />
          <Route
            path="accounts"
            element={
              <RequireAuth>
                <Accounts />
              </RequireAuth>
            }
          />
          <Route
            path="firms"
            element={
              <RequireAuth>
                <Firms />
              </RequireAuth>
            }
          />
          <Route
            path="data"
            element={
              <RequireAuth>
                <Data />
              </RequireAuth>
            }
          />
          <Route
            path="trade-log"
            element={
              <RequireAuth>
                <TradeLog />
              </RequireAuth>
            }
          />
          <Route
            path="payouts"
            element={
              <RequireAuth>
                <Payouts />
              </RequireAuth>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
